export enum BlogCategory {
  News = 'news',
  Guides = 'guides',
  Reviews = 'reviews',
  Tips = 'tips',
  Betting = 'betting',
}

export function isBlogCategory(category: string): category is BlogCategory {
  return Object.values(BlogCategory).includes(category as BlogCategory);
}
